'use client';

import { WithClassName } from 'src/utils/UtilityTypes';
import TextButton from '../primitives/TextButton/TextButton';

interface ExpandAllButtonProps extends WithClassName {
	areAllItemsExpanded: boolean;
	totalCount: number;
	onExpandAll: () => void;
	onCollapseAll: () => void;
	dataTestId?: string;
}

function ExpandAllButton({
	areAllItemsExpanded,
	totalCount,
	onExpandAll,
	onCollapseAll,
	className,
	dataTestId,
}: ExpandAllButtonProps) {
	if (totalCount === 0) return null;

	return (
		<div className="flex w-16 justify-end">
			{areAllItemsExpanded ? (
				<TextButton
					variant="tertiary"
					size="sm"
					className={className}
					onClick={onCollapseAll}
					dataTestId={dataTestId}
				>
					Collapse All
				</TextButton>
			) : (
				<TextButton
					variant="tertiary"
					size="sm"
					className={className}
					onClick={onExpandAll}
					dataTestId={dataTestId}
				>
					Expand All
				</TextButton>
			)}
		</div>
	);
}

export default ExpandAllButton;
